<!--
 * @Author: zn
 * @Date: 2022-09-14 16:30:35
 * @LastEditors: zn
 * @LastEditTime: 2022-09-29 11:29:58
 * @FilePath: \huangshi_door\src\views\center\ApplyNo.vue
-->
<template>
  <div class="applyNo">
    <h3 class="title">无申请兑现</h3>
    <apply-all></apply-all>
    <!-- <el-tabs class="applyTab" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane class="tabTitle" label="全部" name="first">
        <apply-all></apply-all>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="审核中" name="second">
        <apply-ing></apply-ing>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="审核通过" name="third">
        <apply-pass></apply-pass>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="已驳回" name="fourth">
        <apply-reject></apply-reject>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="待上传收据" name="fifth">
        <upload-data></upload-data>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="已兑现" name="sixth">
        <to-cash></to-cash>
      </el-tab-pane>
      <el-tab-pane class="tabTitle" label="已放弃" name="seventh">
        <give-up></give-up>
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>
<script>
import ApplyAll from "./components/ApplyAll.vue";
import ApplyIng from "./components/ApplyIng.vue";
import ApplyPass from "./components/ApplyPass.vue";
import ApplyReject from "./components/ApplyReject.vue";
import UploadData from "./components/UploadData.vue";
import ToCash from "./components/ToCash.vue";
import GiveUp from "./components/GiveUp.vue";
export default {
  name: "ApplyNo",
  components: {
    ApplyAll,
    ApplyIng,
    ApplyPass,
    ApplyReject,
    UploadData,
    ToCash,
    GiveUp,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },
};
</script>
<style lang="scss" scoped>
.applyNo {
  .title {
    font-size: 18px;
    line-height: 18px;
    font-weight: bold;
    color: rgba(56, 56, 56, 1);
    margin: 0 0 15px 0;
  }
  .applyTab {
    border-top: 2px solid #e4e7ed;
    /deep/.el-tabs__item {
      padding: 0 20px;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      color: rgba(56, 56, 56, 1);
    }
    /deep/.selectForm {
      .el-form-item {
        margin-right: 5%;
      }
      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }
  }
}
</style>
